import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { ComponentRegistry } from 'core/registry';
import { Label, FormField, Optional, FormEmoji } from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { TextAreaField } from 'libs/forms/views/fieldTypes/textArea';
import FormActionButton from 'libs/forms/views/formActionButton';
import { ModalTitle, Center } from 'legacyComponents/styled/lib';

import { SignInFormWrapper } from 'apps/signIn/styles';

import { Modal } from 'apps/modals/views/modal';
import { AccessFormAppManager } from 'apps/profile/accessForm/appManager';

@withNamespaces()
@observer
export class AccessForm extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new AccessFormAppManager(null, {
      autoFocus: true,
    });
  }

  render() {
    const { form, Submit } = this.appManager;
    const {
      conf: { formTitle },
    } = form;
    const emailFieldStore = form.fieldStores.get('email');
    const bioFieldStore = form.fieldStores.get('bio');
    return (
      <>
        <ModalTitle>{formTitle}</ModalTitle>
        <FormEmoji>👋</FormEmoji>
        <SignInFormWrapper
          posting={form.posting}
          onSubmit={e => {
            e.preventDefault();
            form.prepare();
            Submit();
          }}
        >
          <FormField>
            <Label>
              <Trans>{emailFieldStore.conf.label}</Trans>
            </Label>
            <TextField fieldStore={emailFieldStore} />
          </FormField>
          <FormField>
            <Label>
              <Trans>{bioFieldStore.conf.label}</Trans>
              <Optional>
                {' '}
                - <Trans>Optional</Trans>
              </Optional>
            </Label>
            <TextAreaField
              fieldStore={bioFieldStore}
              validationPosition={{ top: '8px', right: '8px' }}
            />
          </FormField>
          <Center>
            <FormActionButton
              formStore={form}
              marginTop='10px'
              marginBottom='20px'
            />
          </Center>
        </SignInFormWrapper>
      </>
    );
  }
}

ComponentRegistry.add('modals.AccessForm', AccessForm);
